import { useMutation } from '@tanstack/react-query';
import { generatePreviewToken } from '../domain/studies.api';
import logger from '@/core/services';
import { HttpError } from '@refinedev/core';

export const useGeneratePreviewToken = () => {
  const { mutate, isLoading } = useMutation({
    mutationFn: generatePreviewToken,
    onError: (error: HttpError) => {
      logger.error('Error generating preview token:', error);
    },
  });
  return { mutate, isLoading };
};
